/* eslint-disable no-else-return */
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ComTable from '@components/common/ComTable';
import { Switch } from 'antd';
import { useLocation } from 'react-router-dom';
import { t } from 'i18next';
import { DEFAULT_VISIBLE_PARTS } from '@common/constant/fab';
import { fabApi } from '@services/fabApi';
import { FabSettingsContext } from '..';

/**
 * Update a specific bit in a binary number
 * @param {number} value - Current 7-bit number
 * @param {number} index - Bit index (0-6)
 * @param {0|1} state - New bit value (0 or 1)
 * @returns {number} Updated number
 */
const updateBit = (value, index, state) => {
  if (state === 1) {
    return value | (1 << index); // Set bit to 1
  } else {
    return value & ~(1 << index); // Set bit to 0
  }
};

const GetVisibleParts = (pagination, fab_visible_parts) => {
  const visibleParts = [];
  const parts = fab_visible_parts.toString(2).padStart(7, '0').split('');
  for (let i = 0; i < parts.length; i++) {
    visibleParts.push({
      order: i + 1,
      name: DEFAULT_VISIBLE_PARTS[i],
      visible: parts[i] === '1',
    });
  }
  const order = pagination.order === 'DESC' ? -1 : 1;
  visibleParts.sort((a, b) => {
    if (a[pagination.order_by] < b[pagination.order_by]) return -1 * order;
    if (a[pagination.order_by] > b[pagination.order_by]) return 1 * order;
    return 0;
  });
  return {
    loadingTable: false,
    value: {
      data: {
        count: parts.length,
        data: pagination.keyword
          ? visibleParts.filter((part) =>
              part.name.includes(pagination.keyword),
            )
          : visibleParts,
      },
    },
  };
};

function FabSettingsList() {
  const { state } = useLocation();
  const didFetch = useRef(false);

  const [pagination, setPagination] = useState({
    page_number: 1,
    page_size: 15,
    fab_id: state?.fab_id,
    fab_visible_parts: state?.fab_visible_parts,
    order: 'ASC',
    name: '',
    order_by: 'order',
  });

  const [optionSelect] = useState([]);
  const { loading, setLoading } = useContext(FabSettingsContext);

  const { loadingTable, value } = useMemo(
    () => GetVisibleParts(pagination, pagination?.fab_visible_parts),
    [pagination],
  );

  const paginationProp = {
    position: ['bottomRight'],
    total: value?.data?.count,
    pageSize: pagination?.page_size,
    currentPage: pagination?.page_number,
  };

  useEffect(() => {
    if (!state?.fab_id || didFetch.current) return;

    didFetch.current = true; // đánh dấu đã fetch 1 lần
    fabApi.getDetailFabs(state.fab_id).then((res) => {
      setPagination((prevPagination) => ({
        ...prevPagination,
        fab_visible_parts: res.data.visible_parts,
      }));
    });
  }, [state?.fab_id]);

  const handleSearch = useCallback(
    (values) => {
      setPagination((curState) => ({
        ...curState,
        keyword: values,
        page_number: 1,
      }));
    },
    [setPagination],
  );

  const onChangeSelect = useCallback(
    (data) => {
      setPagination((curState) => ({
        ...curState,
        fab_id: data,
      }));
    },
    [setPagination],
  );

  const handleChangePagination = useCallback(
    (currentPage, pageSize) => {
      setPagination((curState) => ({
        ...curState,
        page_size: pageSize,
        page_number: currentPage,
      }));
    },
    [setPagination],
  );

  const hanldeChangeTable = useCallback(
    (_, filter, sorter) => {
      if (sorter?.order === 'descend') {
        setPagination((curState) => ({
          ...curState,
          order: 'DESC',
          order_by: sorter?.field,
        }));
      } else {
        setPagination((curState) => ({
          ...curState,
          order: 'ASC',
          order_by: sorter?.field,
        }));
      }
    },
    [setPagination],
  );

  const handleSwitchChange = useCallback(
    async (fabId, visibleParts, order, switchOn) => {
      if (!fabId) return;

      setLoading(true);
      try {
        const bitPosition = 7 - order;
        const updatedBits = updateBit(
          visibleParts,
          bitPosition,
          switchOn ? 1 : 0,
        );
        const response = await fabApi.updateVisibleParts(fabId, {
          visible_parts: updatedBits,
        });
        if (response.statusCode === 200) {
          setPagination((prevState) => ({
            ...prevState,
            fab_visible_parts: updatedBits,
          }));
        }
      } catch (error) {
        // console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, setPagination],
  );

  const columns = useMemo(() => {
    return [
      {
        title: t('fab_setting.table.no'),
        dataIndex: 'order',
        sorter: true,
        sortDirections: ['ascend', 'descend', 'ascend'],
        key: 'order',
        width: 80,
        align: 'center',
      },
      {
        title: t('fab_setting.table.part_name'),
        dataIndex: 'name',
        sorter: true,
        sortDirections: ['ascend', 'descend', 'ascend'],
        key: 'name',
      },
      {
        title: t('fab_setting.table.visible'),
        dataIndex: 'visible',
        key: 'visible',
        width: 120,
        render: (visible, values) => {
          return (
            <div className="display-flex jc-center pointer">
              <Switch
                className="w-32"
                checked={visible}
                defaultChecked={visible}
                onChange={(switchOn) =>
                  handleSwitchChange(
                    pagination?.fab_id,
                    pagination?.fab_visible_parts,
                    values?.order,
                    switchOn,
                  )
                }
              />
            </div>
          );
        },
      },
    ];
  }, [pagination]);

  return (
    <div className="fab-settings-list-wrapper full-width">
      <ComTable
        showPagination={false}
        showAddButton={false}
        title={
          state?.fab_name ? `${'Fab'} ${'-'} ${state?.fab_name}` : `${'Fab'}`
        }
        loading={loadingTable || loading}
        columns={columns}
        data={value?.data?.data}
        pagination={paginationProp}
        onSearch={handleSearch}
        optionSelect={optionSelect}
        onChangeSelect={onChangeSelect}
        onChangeTable={hanldeChangeTable}
        onChangePagination={handleChangePagination}
      />
    </div>
  );
}
FabSettingsList.propTypes = {};

export default FabSettingsList;
